export const MEDALLIA_FERGHOME_FORM_ID = 52183;
export const MEDALLIA_EMPLOYEE_FORM_ID = 58177;
